import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';

import type { EditorAPI } from '#packages/editorAPI';

export const toggleSlotOpenerUserPreferences = (editorAPI: EditorAPI) => {
  editorAPI.store.dispatch(
    stateManagement.userPreferences.actions.setSiteUserPreferences(
      constants.USER_PREFS.VIEW_TOOLS.SLOT_OPENER_ENABLED,
      !getSlotOpenerUserPreferences(editorAPI),
    ),
  );
};

export const getSlotOpenerUserPreferences = (editorAPI: EditorAPI) => {
  const slotOpenerUserPreferences =
    stateManagement.userPreferences.selectors.getSiteUserPreferences(
      constants.USER_PREFS.VIEW_TOOLS.SLOT_OPENER_ENABLED,
    )(editorAPI.store.getState());

  return slotOpenerUserPreferences !== undefined
    ? slotOpenerUserPreferences
    : true;
};
